import { ids } from "@icarros/theme-react";
import styled from "styled-components";
import { Contrast } from "../../../types/general.types";
const { size, color } = ids || {};
export const StyledDotIndicator = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
`;
export const StyledDotsContainer = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  gap: ${size.general.ids_size_general_4x};
`;
export const StyledDot = styled.span `
  width: ${size.general.ids_size_general_6x};
  height: ${size.general.ids_size_general_6x};
  border: ${size.border_width.ids_size_border_small} solid
    ${({ contrast }) => contrast === Contrast.dark
    ? color.contrast.ids_color_contrast_onBrand_primary
    : color.action.neutral.ids_color_action_neutral_base};
  border-radius: 100%;
  &:nth-child(${({ actual }) => actual}) {
    background: ${({ contrast }) => contrast === Contrast.dark
    ? color.contrast.ids_color_contrast_onBrand_primary
    : color.action.neutral.ids_color_action_neutral_base};
  }
`;
//# sourceMappingURL=DotIndicator.style.js.map